import { observable, action, configure, computed } from 'mobx';
import { persist } from 'mobx-persist';

import { parseISO, differenceInSeconds } from 'date-fns';
import { jwtToken } from 'shared/authorizations';
import { decodeJwtToken } from 'shared/jwt';
import { UserTypeValues } from 'shared/constants';

configure({ enforceActions: 'always' }); // strict mode

const initialUserLogin: any = {
  expirationDate: '',
  jwt: null,
  userName: '',
  userFullName: '',
};

const initialCollectionPointLogin: any = {
  expirationDate: '',
  jwt: null,
  collectionpointId: null,
};

//------------------------------------------------------
// *    --- Functions ---
//

// *    --- Store Class ---
//
export class AppStore {
  @observable initialized = false;
  @persist('object') @observable userLogin = { ...initialUserLogin };
  @persist('object') @observable.ref collectionpointLogin = initialCollectionPointLogin;
  @persist @observable user = '';
  @persist @observable dbAlias = '';
  @persist @observable pageSize = 10;
  @observable jwtExpireLeft = 0;
  @action setPageSize(n: number): void {
    if (n > 0) this.pageSize = n;
  }

  @observable curDate = new Date(); // Ημέρα Ζυγίσεων

  /**
   * Global Busy Logic
   */
  @observable private busyCnt = 0;
  @observable private busyReg = false;
  @observable private progressCnt = 0;
  @computed get busy(): boolean {
    return this.busyCnt > 0 || this.busyReg;
  }
  @computed get progress(): number {
    return Math.ceil(this.progressCnt);
  }
  @action regBusy(value: boolean): void {
    //log.log('[AppStore]: regBusy +', value);
    this.busyReg = value;
  }
  @action setBusy(): void {
    this.busyCnt++;
    //log.log('[AppStore]: Busy +', this.busyCnt);
  }
  @action setProgress(value: number): void {
    this.progressCnt = value;
    //log.log('[AppStore]: Busy +', this.busyCnt);
  }
  @action clearBusy(): void {
    this.busyCnt--;
    //log.log('[AppStore]: Busy -', this.busyCnt);
  }
  @action clearProgress(): void {
    this.progressCnt = 0;
    //log.log('[AppStore]: Busy -', this.busyCnt);
  }

  // *
  // * --------------- Getters -------------------------------
  @computed get isLogIn(): boolean {
    console.log('[app-store] isLogin', JSON.stringify(!!this.collectionpointLogin?.jwt));
    return !!this.collectionpointLogin?.jwt;
  }

  buildContext = function (): any {
    return { jwtToken: decodeJwtToken(this.collectionpointLogin.jwt) };
  };

  @computed get userRolesIds(): Array<any> {
    const jwt = decodeJwtToken(this.collectionpointLogin.jwt);
    return jwt.userRolesIds;
  }

  @computed get usertypeId(): number {
    const context: any = this.buildContext();
    const jwt = jwtToken(context);
    return jwt.userTypeId;
  }

  @computed get isPlatformOwner(): boolean {
    return this.usertypeId === UserTypeValues.PlatformOwner;
  }

  @computed get isCollector(): boolean {
    return this.usertypeId === UserTypeValues.Collector;
  }

  @computed get isCollectorDriver(): boolean {
    return this.usertypeId === UserTypeValues.CollectorDriver;
  }

  @computed get isCollectionPoint(): boolean {
    return this.usertypeId === UserTypeValues.CollectionPoint;
  }

  @computed get isWasteReceptionPoint(): boolean {
    return this.usertypeId === UserTypeValues.WasteReceptionPoint;
  }

  @computed get isContributor(): boolean {
    return this.usertypeId === UserTypeValues.Contributor;
  }

  @computed get associatedId(): number {
    const jwt = decodeJwtToken(this.collectionpointLogin.jwt);
    return jwt.associatedId;
  }

  @computed get userFullName(): string {
    return this.collectionpointLogin.userFirstName + ' ' + this.collectionpointLogin.userLastName;
  }

  @computed get calcJwtExpireLeft(): number {
    if (!this.isLogIn) return 0;
    return differenceInSeconds(parseISO(this.collectionpointLogin.expirationDate), new Date());
  }
  // * --------------- Methods -------------------------------

  @action login(user: string, userData: any): void {
    this.user = user;
    this.collectionpointLogin.jwt = userData.jwt;
    this.collectionpointLogin.expirationDate = userData.expirationDate;
    this.collectionpointLogin.collectionpointId = userData.collectionpointId;

    const dt = new Date(Date.now());
    sessionStorage.setItem('date', dt.toLocaleDateString() + ' ' + dt.toLocaleTimeString());
  }

  @action logOut(): void {
    this.user = '';
    this.dbAlias = '';
    this.collectionpointLogin = { ...initialCollectionPointLogin };
  }

  @action setCurDate(newDate: Date): void {
    this.curDate = newDate;
  }

  @action private setJwtExpiredLeft(): void {
    this.jwtExpireLeft = this.calcJwtExpireLeft;
    if (this.jwtExpireLeft < 0) this.logOut();
  }

  @action initialize(): void {
    this.setJwtExpiredLeft();
    this.initialized = true;
  }

  constructor() {
    this.init();
  }

  @action private init() {
    //log.log([AppStore] init);
    // console.log([AppStore] init values= , this.user, this.userLogin);
    // this.user = '';
    // this.userLogin = { ...initialUserLogin };
    // setInterval(() => {
    //   this.setJwtExpiredLeft();
    // }, 1000);
  }

  //const { userParams } = useUserPermissions();
  @persist('list') @observable userParams: Array<any> = [];
  @action setUserParams(values) {
    this.userParams = values;
  }
}
